var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2785_481)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#0A62F1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2785_481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.84375 11.125H5.65625C5.29381 11.125 5 11.4188 5 11.7812V18.3438C5 18.7062 5.29381 19 5.65625 19H7.84375C8.20619 19 8.5 18.7062 8.5 18.3438V11.7812C8.5 11.4188 8.20619 11.125 7.84375 11.125ZM6.75 17.9062C6.38756 17.9062 6.09375 17.6124 6.09375 17.25C6.09375 16.8876 6.38756 16.5938 6.75 16.5938C7.11244 16.5938 7.40625 16.8876 7.40625 17.25C7.40625 17.6124 7.11244 17.9062 6.75 17.9062ZM15.5 7.2272C15.5 8.38702 14.7899 9.03758 14.5901 9.8125H17.3716C18.2848 9.8125 18.9957 10.5712 19 11.4011C19.0023 11.8916 18.7936 12.4196 18.4684 12.7463L18.4654 12.7494C18.7344 13.3875 18.6907 14.2816 18.2109 14.9223C18.4483 15.6304 18.209 16.5002 17.763 16.9665C17.8805 17.4477 17.8243 17.8572 17.5949 18.1869C17.0368 18.9887 15.6536 19 14.4839 19L14.4061 19C13.0857 18.9995 12.0051 18.5188 11.1369 18.1325C10.7005 17.9384 10.13 17.6981 9.69719 17.6901C9.51836 17.6868 9.375 17.5409 9.375 17.3621V11.5168C9.375 11.4293 9.41005 11.3453 9.47229 11.2838C10.5555 10.2134 11.0213 9.08023 11.9091 8.19091C12.3139 7.78534 12.4611 7.17273 12.6034 6.5803C12.725 6.07442 12.9794 5 13.5312 5C14.1875 5 15.5 5.21875 15.5 7.2272Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2785_481",
    x: 0,
    y: 0,
    width: 24,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2785_481"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2785_481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/Like.07fd7d74f608ce8321b4b60a1fd08be7.svg";
export { ForwardRef as ReactComponent };